const resumeCodePattern = /^[A-Za-z0-9_-]{43}$/;

export const consumeConversationResumeFragment = (
  currentUrl: string,
): { code: string; cleanedUrl: string } | null => {
  const url = new URL(currentUrl);
  const raw = url.hash.startsWith('#') ? url.hash.slice(1) : '';
  const parameters = new URLSearchParams(raw);
  const code = parameters.get('jake_resume');
  if (!code || !resumeCodePattern.test(code)) return null;
  parameters.delete('jake_resume');
  const remainder = parameters.toString();
  return {
    code,
    cleanedUrl: `${url.pathname}${url.search}${remainder ? `#${remainder}` : ''}`,
  };
};
